export const UNITS = {
  ft: 0.3048,
  km: 1000,
  m: 1,
  mi: 1609.34,
  yd: 0.9144
}
